<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">
      <ng-container>
        Could you please provide a brief explanation for the deletion request.
      </ng-container>
    </h4>
    <button type="button" class="close" (click)="close()">×</button>
  </div>
  <div class="modal-body">
    <form [formGroup]="TerminalFormGroup" role="form" autocomplete="off">


      <div class="form-group row">
        <div class="col-12">
          <textarea rows="4" formControlName="noteFC" class="form-control" id="noteFC" placeholder="Could you please provide a brief explanation for the deletion request."></textarea>
        </div>
      </div>

      <div class="form-group row offset-3 col-9" *ngIf="!!createResult && createResult.success == false">
        <ng-container *ngIf="!!createResult.message">
          <p class="text-danger">{{createResult.message}}</p>
        </ng-container>
      </div>

      <div class="form-group row offset-3 col-9" *ngIf="!!createResult && createResult.success">
        <ng-container *ngIf="!!createResult.message">
          <p class="text-success">{{createResult.message}}</p>
        </ng-container>
      </div>

      <div class="form-group row float-right">
        <div class="col-12">
          <button type="submit" class="btn btn-danger" (click)="delete()">Delete ticket</button>
        </div>
      </div>
    </form>
  </div>
</div>
